module.exports = __webpack_public_path__ + "static/media/match_word.fb0ce949.svg";